import DropzoneHook from './dropzone.js'
import DraggableHook from './draggable.js'
// see https://medium.com/codex/drag-n-drop-with-vanilla-javascript-75f9c396ecd for some of this.

export default { DropzoneHook, DraggableHook }
